<div class="pt-2 block-profile" *ngIf="userBlockIsVisible()">
  <a [routerLink]="['/home']">
    <!-- <div class="brand-logo"  >
            <img class="img-fluid mt-2 ml-3" src="assets/img/black-logo.png" alt="FastSwiff" />
        </div> -->
    <div class="brand-logo" *ngIf="fastswiffimage">
      <img
        class="img-fluid mt-2"
        src="assets/img/dashboard_icons/darklogo.svg"
        width="75%"
        alt="FastSwiff"
      />
    </div>

    <!-- <div class="brand-logo text-center" *ngIf="image">

      <img [ngStyle]="{'width': +'px', 'height': +'px'}" class="res-h img-fluid image-cropper-container1"
        src="data:image/jpeg;base64,{{content}}" alt="FastSwiff" />
    </div> -->
  </a>
  <div class="profile-colleps">
    <div class="d-flex flex-column mt-3">
      <!-- Company Name Label -->
      <label style="font-size: 18px; color: var(--white)" class="m-0 p-0">
        {{ CompanyName }}
      </label>

      <!-- MID for Trial Mode or Active Mode -->
      <label
        *ngIf="!showActive"
        (click)="toggleDropdown()"
        style="font-size: 10px; color: var(--grey5)"
        class="m-0 p-0"
      >
        <span style="color: var(--main1); font-weight: bold"></span>
        MID:{{ MId }}
        <span class="m-0 p-0" style="color: var(--white)">
          (Trial Mode)
          <img
            src="./assets/img/settings.svg"
            style="cursor: pointer; margin-bottom: 5%"
            alt="Settings"
          />
        </span>
      </label>

      <label
        *ngIf="showActive"
        (click)="toggleDropdown()"
        style="font-size: 10px; color: var(--grey5)"
        class="m-0 p-0"
      >
        <span style="color: var(--main1); font-weight: bold"></span>
        MID:{{ MId }}
        <span class="m-0 p-0" style="color: var(--white)">
          (Active)
          <img
            src="./assets/img/settings.svg"
            style="cursor: pointer; margin-bottom: 5%"
            alt="Settings"
          />
        </span>
      </label>
    </div>

    <!-- Dropdown Menu for Profile -->
    <div style="display: flex; justify-content: center">
      <div class="dropdown-container" [collapse]="!profilemenu">
        <!-- Account Option -->
        <div
          class="dropdown-item"
          (click)="profilemenu = !profilemenu"
          [routerLink]="['/transactions/profile']"
          style="display: flex; align-items: center; cursor: pointer"
        >
          <img
            src="assets/img/fastswifficon/profile.svg"
            alt="Profile"
            style="width: 20px; margin-right: 8px"
          />
          <p class="m-0">Account</p>
        </div>

        <!-- Settings Option -->
        <div
          class="dropdown-item mt-2"
          (click)="profilemenu = !profilemenu"
          [routerLink]="['/settings/merchantsettings']"
          style="display: flex; align-items: center; cursor: pointer"
        >
          <img
            src="assets/img/fastswifficon/settings-2.svg"
            alt="Settings"
            style="width: 20px; margin-right: 8px"
          />
          <p class="m-0">Settings</p>
        </div>

        <!-- Help Ticket Option -->
        <div
          class="dropdown-item mt-2"
          (click)="profilemenu = !profilemenu"
          [routerLink]="['/Ticket/MangeTicket']"
          style="display: flex; align-items: center; cursor: pointer"
        >
          <img
            src="assets/img/fastswifficon/help-2.svg"
            alt="Help Ticket"
            style="width: 20px; margin-right: 8px"
          />
          <p class="m-0">Help Ticket</p>
        </div>
      </div>
    </div>
  </div>

  <div
    style="
      border-radius: 50%;
      background-color: var(--main1);
      padding: auto;
      cursor: pointer;
    "
    class="collapseLogout mt-3 ml-3"
  >
    <span
      class="material-symbols-outlined p-2 collapseIcon"
      title="Logout"
      [routerLink]="['/login']"
    >
      logout
    </span>
  </div>
</div>
